<script setup lang="ts">
defineOptions({ inheritAttrs: false });

const { t } = useI18n();

withDefaults(
  defineProps<{
    loading?: boolean;
    hideTextOnLoad?: boolean;
  }>(),
  { loading: false, hideTextOnLoad: false }
);
</script>

<template>
  <UButton v-bind="{ ...$attrs, disabled: loading || !!$attrs.disabled }" class="relative gap-x-2.5">
    <div
      v-if="loading"
      :class="{ 'absolute inset-0 size-full': hideTextOnLoad, '-ml-1': !hideTextOnLoad }"
      class="flex items-center justify-center"
      role="status"
    >
      <span class="motion-safe:animate-spin block size-4 rounded-full border-[2.5px] border-current/25 border-t-current" aria-hidden="true" />
      <span class="sr-only">{{ t("ui.loading") }}</span>
    </div>
    <span :class="{ invisible: loading && hideTextOnLoad }">
      <slot />
    </span>
  </UButton>
</template>
